import { Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
    selector: "app-input-box",
    templateUrl: "./input-box.component.html",
    styleUrls: ["./input-box.component.scss"],
})
export class InputBoxComponent {
    @Input() inputModel: any
    @Input() maxLength: number
    @Input() shouldCheckCharsDirective = false
    @Input() customRegEx: RegExp
    @Output() inputModelChange = new EventEmitter<string>()
    @Input() public label: string = ""
    @Input() public note?: string = ""
    @Input() public linkLabel?: string = ""
    @Input() public linkTarget?: string = ""
    @Input() public isInputDisabled?: boolean = false
    @Input() public inputType?: string = "text"
    @Input() public isCheck?: boolean = false
    @Input() public isLinkExternal?: boolean = true
    @Output() linkClicked = new EventEmitter<string>()
}
